import script from "./BookingHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingHistory.vue?vue&type=script&lang=ts&setup=true"

import "./BookingHistory.vue?vue&type=style&index=0&id=c20c3828&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c20c3828"]])

export default __exports__